import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=42ba0684"
import script from "./Attachments.vue?vue&type=script&lang=js"
export * from "./Attachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports